import { scrollToNextSection } from '../helpers/scrollHelpers';

const scrollToFuncs = () => {
	const nextSectionTriggers = document.querySelectorAll('.js-scroll-to-next-section');
	if (nextSectionTriggers.length) {
		nextSectionTriggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				scrollToNextSection(trigger);
			});
		});
	}
};

scrollToFuncs();
